import moment from 'moment'

import { ETimeUnit, TimeWindowInterval } from '@types'

export const generateDateInterval = (
  timeInterval: TimeWindowInterval,
  timeUnit: ETimeUnit = ETimeUnit.HOUR
) => {
  // Проверяем, что входные данные корректны
  if (!Array.isArray(timeInterval) || timeInterval.length < 3) {
    throw new Error('Invalid input data format')
  }

  const [currentDateStr, leftOffset, rightOffset] = timeInterval

  // Создаем момент текущей даты
  const currentDate = moment(currentDateStr)
  const unit = timeUnit.toLowerCase() as moment.unitOfTime.DurationConstructor

  // Проверяем, что дата валидна
  if (!currentDate.isValid()) {
    throw new Error('Invalid date format')
  }

  // Вычисляем start и end даты
  const startDate = currentDate
    .clone()
    .subtract(Math.abs(parseInt(leftOffset)), unit as moment.unitOfTime.DurationConstructor)
  const endDate = currentDate
    .clone()
    .add(Math.abs(parseInt(rightOffset)), unit as moment.unitOfTime.DurationConstructor)

  // Возвращаем результат в ISO формате (можно изменить на нужный формат)
  return {
    start: startDate.toISOString(),
    end: endDate.toISOString(),
  }
}
